<template lang="pug">
.sv-table
    .sv-table__header
        .sv-table__header-cell(
            v-for="header in headers"
            :key="header.title"
            :style="{ width: header.width }"
        )
            | {{ header.title }}

    .sv-table__body
        .sv-table__row(
            v-for="(el, row) in body"
            :key="row"
            @click="transfer(el)"
        )
            .sv-table__cell(
                v-for="header in headers"
                :key="header.path + el"
                :style="{ width: header.width }"
            )
                | {{ el[header.path] }}

        .sv-table__empty(
          v-if="!body.length"
        )
          | {{ emptyText }}
</template>

<script>
export default {
  name: 'SvTable',

  props: {
    headers: {
      type: Array,
      required: true,
    },

    body: {
      type: Array,
      default: () => [],
    },

    emptyText: {
      type: String,
      default: 'Здесь пока ничего нет',
    },
  },

  methods: {
    transfer(el) {
      this.$emit('transfer', el);
    },
  },
};
</script>

<style lang="scss" scoped>
.sv-table {
  &__header {
    display: flex;
    background-color: #F8F8FA;
    border-radius: 15px 15px 0px 0px;
    height: 65px;
    align-items: center;
    font-size: 12px;
    text-transform: uppercase;
    color: #B6BAC6;
    font-weight: 500;
    padding: 0 60px;
  }

  &__empty {
    display: flex;
    justify-content: center;
    height: 130px;
    align-items: center;
    font-size: 14px;
    color: #A7ABB7;
    font-weight: 500;
  }

  &__body {
    display: flex;
    flex-direction: column;
    border-radius: 0px 0px 15px 15px;

    .sv-table__row {
      display: flex;
      cursor: pointer;
      padding: 0 60px;
      border-bottom: 1px solid #E4E5EA;
      height: 65px;
      transition: box-shadow ease-in-out .1s;

      &:last-child {
        border-radius: 0 0 15px 15px;
      }

      &:hover {
        box-shadow: 0px 5px 10px rgba(13, 18, 63, 0.07);
      }
    }

    .sv-table__cell {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #404450;
    }
  }
}
</style>
